import { ICustomTheme, createTheme } from '../theme';

const theme: ICustomTheme = {};

export default theme;
